export default class CustomText {
  readonly id: number
  readonly key: string
  readonly text: string
  readonly category: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.key = data.key
    this.text = data.text
    this.category = data.category
  }
}
